import { Fragment } from "react";
import { Box, SxProps, Theme, Typography } from "@mui/material";
import { intl } from "LocaleWrapper";
import { GeneralEntityChangeFragment as EntityChange } from "__generated__/components/entityHistory/graphql/entityHistory.fragments.generated";
import { ChangeType } from "__generated__/enums";
import EntityHistoryValue from "components/entityHistory/components/EntityHistoryValue";
import GroupHeader from "./GroupHeader";

const ListRevisionChanges = ({ changes }: {
	changes: EntityChange[];
}) => (
	<Box
		sx={{
			display: "grid",
			gridTemplateColumns: "min-content 1fr 1fr 2fr 2fr",
			alignItems: "stretch",
		}}
	>
		{([
			{ id: null },
			{ id: "ENTITY" },
			{ id: "FIELD" },
			{ id: "OLD_VALUE" },
			{ id: "NEW_VALUE" },
		]).map(header => (
			<Box
				key={header.id}
				sx={{
					pr: 1.5,
					display: "flex",
					alignItems: "center",
					justifyContent: "flex-start",
					borderBottom: "1px solid",
					borderColor: "divider",
				}}
			>
				{header.id && (
					<Typography variant="caption" color="text.secondary" fontWeight={600}>
						{intl.formatMessage({ id: header.id })}
					</Typography>
				)}
			</Box>
		))}
		{changes.map((change, index) => {
			const backgroundColor = index % 2 === 1 ? (
				"action.hover"
			) : (
				"transparent"
			);

			const cell: Readonly<SxProps<Theme>> = {
				backgroundColor,
				py: 0.5,
				pr: 1.5,
				display: "flex",
				alignItems: "center",
				flexWrap: "wrap",
				gap: 0.5,
			};

			return (
				<Fragment key={change.id}>
					<GroupHeader sx={cell} entity={change} />
					<Box sx={cell}>
						{change.fieldKey && (
							<Typography
								component="span"
								variant="caption"
								sx={{
									fontWeight: 600,
									bgcolor: "action.selected",
									borderRadius: 0.5,
									px: 0.75,
									py: 0.25,
								}}
							>
								{intl.formatMessage({ id: change.fieldKey })}
							</Typography>
						)}
					</Box>
					<Box sx={{ ...cell }}>
						{change.changeType !== ChangeType.Insert && (
							<EntityHistoryValue value={change.oldValue} strikeThrough />
						)}
					</Box>
					<Box sx={cell}>
						{change.changeType !== ChangeType.Delete && (
							<EntityHistoryValue value={change.newValue} />
						)}
					</Box>
				</Fragment>
			);
		})}
	</Box>
);

export default ListRevisionChanges;
